export const EDGEGATEWAY = "EDGEGATEWAY"